// Import styles
import "../styles/index.css"

// Import Turbo first
import * as Turbo from "@hotwired/turbo"

// Import Stimulus
import { Application } from "@hotwired/stimulus"
import { registerControllers } from "./controllers"

// Start Stimulus application
const application = Application.start()

// Register all Stimulus controllers
registerControllers(application)

// Configure and start Turbo using the new syntax
Turbo.config.drive.progressBarDelay = 100
Turbo.start()

// Debug Turbo events only when debug parameter is present
if (new URLSearchParams(window.location.search).get('debug')) {
  document.addEventListener('turbo:load', () => console.log('Turbo load event fired'))
  document.addEventListener('turbo:render', () => console.log('Turbo render event fired'))
}